import { PageUiService } from '@safarilaw-webapp/shared/ui-kit/basepage';
import { LpmsBasePage } from '../../lpms-base-page';
import { matterSubtypesMixin } from '../../shared/components/base/mixins/matter-subtype-mixin';

export class MatterBasePage<PageServiceType extends PageUiService = PageUiService> extends matterSubtypesMixin(LpmsBasePage)<PageServiceType> {
  constructor() {
    super();
  }
}
